/**
 * Mobile Swipe-to-Reveal for Product Card Actions (Quick View / Compare)
 * ─────────────────────────────────────────────────────────────────────
 * On touch devices, ANY swipe (≥ 30 px in any direction) on a product
 * card reveals the Quick-View & Compare buttons by adding the class
 * `tdp-card-swiped`. Only one card can be "open" at any time.
 *
 * A tap anywhere outside the swiped card closes it, so the card link
 * works normally on the next tap.
 */
(function () {
  if (!('ontouchstart' in window)) return; // not a touch device

  const SWIPE_THRESHOLD = 30;  // min px in any direction
  const SWIPED_CLASS    = 'tdp-card-swiped';

  let startX = 0;
  let startY = 0;
  let activeCard = null; // only one card can be "swiped-open" at a time

  function closeCurrent() {
    if (activeCard) {
      activeCard.classList.remove(SWIPED_CLASS);
      activeCard = null;
    }
  }

  document.addEventListener('touchstart', function (e) {
    const touch = e.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    const touch = e.changedTouches[0];
    const dx    = Math.abs(touch.clientX - startX);
    const dy    = Math.abs(touch.clientY - startY);

    // Any swipe that exceeds the threshold in any direction
    if (dx < SWIPE_THRESHOLD && dy < SWIPE_THRESHOLD) return;

    const card = e.target.closest('.tdp-product-card');

    if (card) {
      // Swipe on a card — reveal buttons
      if (activeCard && activeCard !== card) closeCurrent();
      card.classList.add(SWIPED_CLASS);
      activeCard = card;
    } else {
      // Swipe outside any card — hide buttons
      closeCurrent();
    }
  }, { passive: true });

  // Tap anywhere outside the active card to close it
  document.addEventListener('click', function (e) {
    if (!activeCard) return;
    // If the click target is inside the active (swiped) card's action
    // buttons, let it through — otherwise close
    if (!e.target.closest('.tdp-quick-view-btn') &&
        !e.target.closest('.tdp-compare-btn') &&
        !e.target.closest('.tdp-card-swiped')) {
      closeCurrent();
    }
  }, true);
})();
